module.exports = __webpack_public_path__ + "08b9dc8dbfdf3ddfb221a0fc34ec3fe7.pdf";